import React from 'react';
import styles from './textBodies.module.css';
import { attributionsFor, classificationOf, groupByAppointment } from '../../../../pages/appointment/modules/diagnoses/diagnoses';

/**
 * Miolo dos diagnósticos (CID-10 e CID-11) no relatório: um bloco por
 * atendimento, do mais recente para o mais antigo, com classificação, código e
 * título oficiais, e a fonte de cada classificação usada no fim.
 *
 * `diagnoses`: diagnósticos do paciente; `appointmentId`: atendimento atual (ou null).
 */
export const DiagnosesReportBody = ({ diagnoses, appointmentId }) => {
  const groups = groupByAppointment(diagnoses);

  return (
    <>
      {groups.map((group) => {
        const isCurrent = appointmentId != null && String(group.appointmentId) === String(appointmentId);
        return (
          <div key={group.appointmentId} className={styles.record}>
            <div className={styles.recordHead}>
              <span className={styles.recordDate}>{group.date}</span>
              {isCurrent && <span className={styles.tag}>Deste atendimento</span>}
            </div>
            {group.items.map((diagnosis) => (
              <div key={diagnosis.id} className={styles.text}>
                <strong>{diagnosis.code}</strong> {diagnosis.title} <span className={styles.muted}>({classificationOf(diagnosis).label})</span>
              </div>
            ))}
          </div>
        );
      })}
      {attributionsFor(diagnoses).map((text) => (
        <div key={text} className={`${styles.observation} ${styles.muted}`}>{text}</div>
      ))}
    </>
  );
};

export default DiagnosesReportBody;
